import * as React from 'react';

type Props = {
  children?: React.ReactNode;
  className?: string;
};

const SelectionBox = ({children, className}: Props) => (
  <div className={`bg-muted p-2 ${className ?? ''}`}>{children}</div>
);

export default SelectionBox;
